import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import content from '@/pages/content/content'
import aboutUs from '@/pages/content/children/aboutUs'
import news from '@/pages/content/children/news'
import newsDetail from '@/pages/content/children/newsDetail'
import joinUs from '@/pages/content/children/joinUs'
import assess from '@/pages/content/children/assess'
import assessDetail from '@/pages/content/children/assessDetail'
import question from '@/pages/content/children/question'
import partner from '@/pages/content/children/partner'
import rent from '@/pages/content/children/rent'
import serverTerms from '@/pages/content/children/serverTerms'
import disclaimer from '@/pages/content/children/disclaimer'


Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      component: home,
    },
    {
      path: '/content',
      component: content,
      children:[
        {
          path: '/aboutUs', 
          component: aboutUs,
          name: '关于探物'
        },
        {
          path: '/news', 
          component: news,
          name: '探物资讯'
        },
        {
          path: '/newsDetail', 
          meta:{menuPath:'/news'},
          component: newsDetail,
          name: '探物资讯'
        },
        {
          path: '/joinUs', 
          component: joinUs,
          name: '加入我们'
        },
        {
          path: '/assess', 
          component: assess,
          name: '产品评测'
        },
        {
          path: '/assessDetail', 
          meta:{menuPath:'/assess'},
          component: assessDetail,
          name: '产品评测'
        },
        {
          path: '/question', 
          component: question,
          name: '常见问题'
        },
        {
          path: '/partner', 
          component: partner,
          name: '商务合作'
        },
        {
          path: '/rent', 
          component: rent,
          name: '租赁中心'
        },
        {
          path: '/serverTerms', 
          component: serverTerms,
          name: '隐私与知识产权说明'
        },
        {
          path: '/disclaimer', 
          component: disclaimer,
          name: '法律声明及服务条款'
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js